import { render, staticRenderFns } from "./postmail.vue?vue&type=template&id=33b37a0a"
import script from "./postmail.vue?vue&type=script&lang=js"
export * from "./postmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports